var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectPraise = function SvgSelectPraise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 2.81247L9.18765 9.18762",
    stroke: "#FFAA33",
    strokeWidth: 1.87494,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43723 2.81261L2.81242 2.81261",
    stroke: "#FFAA33",
    strokeWidth: 1.87494,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81264 8.43726L2.81264 2.81245",
    stroke: "#FFAA33",
    strokeWidth: 1.87494,
    strokeLinecap: "round"
  }))));
};
export default SvgSelectPraise;